module.exports = __webpack_public_path__ + "media/images/products/gv500ma/gv500ma-1-400x400-6de8f604d282d6c6c388960e2696033c.png";